function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.84408 6.00254L7.33325 1.51317C7.45686 1.38985 7.52486 1.22498 7.52486 1.04917C7.52486 0.873268 7.45686 0.708488 7.33325 0.584976L6.93988 0.191805C6.81647 0.0680976 6.65149 0 6.47569 0C6.29988 0 6.1351 0.0680976 6.01159 0.191805L0.666515 5.53678C0.542515 5.66068 0.474612 5.82624 0.4751 6.00224C0.474612 6.17902 0.542417 6.34439 0.666515 6.46839L6.00661 11.8082C6.13013 11.9319 6.29491 12 6.47081 12C6.64661 12 6.81139 11.9319 6.935 11.8082L7.32827 11.415C7.58417 11.1591 7.58417 10.7425 7.32827 10.4867L2.84408 6.00254Z",
  fill: "#E0E0E0"
});
function SvgArrowLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftIcon);
export default __webpack_public_path__ + "static/media/arrow-left-icon.6393acae.svg";
export { ForwardRef as ReactComponent };